import './App.css';
import PortalHome from './pages/PortalHome';
import Overview from './pages/Overview';
import CreateEvent from './pages/CreateEvent'
import CreateVenue from './pages/CreateVenue'
import { Routes, Route } from "react-router-dom"
import SignInModal from './components/SignInModal';
import NavbarWow from './components/Navbar';
import { connect } from 'react-redux';
import { useCookies } from 'react-cookie';
import EditEvent from './pages/EditEvent';
import ForgotPassword from './pages/ForgotPassword';

function App(props) {

  const internalRoutes = () => {
    console.log(props.userRole)
    if (props.userRole === 1) {
      return (
        <Routes>
          <Route path="/" element={<PortalHome />} />
          <Route path="/overview" element={<Overview />} />
          <Route path="create-venue" element={<CreateVenue />} />
          <Route path="create-event" element={<CreateEvent />} />
          <Route path="edit-event">
            <Route path=":eventId" element={<EditEvent />} />
          </Route>
          <Route path="/forgotpassword" element={<ForgotPassword />} />
        </Routes>
      )
    } else if (props.userRole === 0) {
      return (
        <Routes>
          <Route path="/" element={<PortalHome />} />
          <Route path="create-event" element={<CreateEvent />} />
          <Route path="/edit-event">
            <Route path=":eventId" element={<EditEvent />} />
          </Route>
          <Route path="/forgotpassword" element={<ForgotPassword />} />
        </Routes>
      )

    }
    else {
      return (
        <Routes>
          <Route path="/" element={<PortalHome />} />
          <Route path="/forgotpassword" element={<ForgotPassword />} />
        </Routes>
      )
    }
  }

  const cookies = useCookies()
  if (cookies.length > 0) {
    if (cookies[0].whatson) {
      if (cookies[0].whatson.role) {
        props.setUserRole(cookies[0].whatson.role)
      }
    }
  }


  return (
    <div style={{backgroundColor:"#091440"}}>
      <SignInModal />
      <NavbarWow userRole={props.userRole} />
      {internalRoutes()}
    </div>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(App);

function mapStateToProps(state) {
  return {
    userRole: state.userRole
  }
}

function mapDispatchToProps(dispatch) {
  return {
    setUserRole: (e) => dispatch({
      type: 'SET_USERROLE',
      text: e
    })
  }
}